export const venuesData = [
  {
    id: 1,
    name: "Lux Frágil",
    type: "Nightclub",
    address: "Avenida Infante Dom Henrique, Armazém A, Cais da Pedra, Santa Apolónia, 1950-376 Lisboa",
    contact: { email: "lux@luxfragil.com", phone: "+351 218 820 890" },
    capacity: 1500,
    hours: "Thu-Sat 11:30pm-7am",
    soundSystem: "Top-tier professional setup, 3 floors",
    pricing: "Entry €10-20",
    bestFor: "Night events",
    website: "www.luxfragil.com",
    social: "@luxfragil",
    notes: "International DJs, rooftop terrace with river views"
  },
  {
    id: 2,
    name: "Kremlin",
    type: "Nightclub",
    address: "Escadinhas da Praia, 5, Santos, 1200-869 Lisboa",
    contact: { email: null, phone: null },
    capacity: 350,
    hours: "Fri-Sat 12am-6am",
    soundSystem: "Upgraded professional system",
    pricing: "Entry €8-15",
    bestFor: "Night events",
    website: null,
    social: "@kremlin.lisboa",
    notes: "Former convent with stone arches, VIP zones"
  },
  {
    id: 3,
    name: "Ministerium Club",
    type: "Nightclub",
    address: "Praça do Comércio, 72, Baixa, 1100-016 Lisboa",
    contact: { email: null, phone: null },
    capacity: "Large",
    hours: "Fri-Sat 12am-7am, Sun 10pm-3am",
    soundSystem: "Professional system",
    pricing: "Entry €10-15",
    bestFor: "Night events",
    website: null,
    social: "@ministeriumclub",
    notes: "Former Finance Ministry building, vaulted ceilings"
  },
  {
    id: 4,
    name: "Musicbox",
    type: "Nightclub/Live Venue",
    address: "Rua Nova do Carvalho, 24, Cais do Sodré, 1200-019 Lisboa",
    contact: { email: null, phone: null },
    capacity: 300,
    hours: "Mon-Sat 11pm-6am",
    soundSystem: "Professional system",
    pricing: "Entry €6-10",
    bestFor: "Night events",
    website: null,
    social: "@musicboxlisboa",
    notes: "Brick arches, live concerts + DJ sets"
  },
  {
    id: 5,
    name: "B.Leza",
    type: "Nightclub",
    address: "Rua Cintura do Porto de Lisboa, Armazém B, Cais do Sodré, 1250-115 Lisboa",
    contact: { email: null, phone: "+351 213 963 735 / +351 210 106 837" },
    capacity: 350,
    hours: "Wed-Sun 10:30pm-4am",
    soundSystem: "Professional system",
    pricing: "Varies by event",
    bestFor: "Night events",
    website: "www.bleza.net",
    social: "@clube.bleza",
    notes: "African music focus, riverside location"
  },
  {
    id: 6,
    name: "K Urban Beach",
    type: "Nightclub",
    address: "Avenida de Brasília, Belém, 1400-038 Lisboa",
    contact: { email: null, phone: null },
    capacity: "Large multi-room",
    hours: "Tue-Sat 8pm-6am, Sun 8pm-12am",
    soundSystem: "Professional system",
    pricing: "Entry €8-15",
    bestFor: "Night events",
    website: null,
    social: null,
    notes: "3 rooms, restaurants, pool"
  },
  {
    id: 7,
    name: "Lust in Rio",
    type: "Nightclub",
    address: "Cais do Gás, Cais do Sodré",
    contact: { email: null, phone: null },
    capacity: "Multi-floor",
    hours: "Wed-Sun",
    soundSystem: "Professional system",
    pricing: "Entry €10-15",
    bestFor: "Night events",
    website: null,
    social: "@lustinrio",
    notes: "2 dance floors, river views, VIP section"
  },
  {
    id: 8,
    name: "Dock's Club",
    type: "Nightclub",
    address: "Rua da Cintura do Porto de Lisboa 226, Alcântara, 1900-109 Lisboa",
    contact: { email: null, phone: "+351 965 882 581" },
    capacity: "Large multi-level",
    hours: "Regular schedule",
    soundSystem: "Professional system",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: null,
    social: null,
    notes: "Former warehouse, waterfront location"
  },
  {
    id: 9,
    name: "Rive Rouge",
    type: "Nightclub",
    address: "Praça Dom Luís I, Time Out Market (1st floor), 1200-148 Lisboa",
    contact: { email: "info@rive-rouge.com", phone: "+351 213 461 117" },
    capacity: "Medium",
    hours: "10pm-6am (opens 5pm)",
    soundSystem: "Professional system",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: null,
    social: null,
    notes: "Red-themed decor, same owners as Lux"
  },
  {
    id: 10,
    name: "Plateau",
    type: "Nightclub",
    address: "Escadinhas da Praia, 7, Santos",
    contact: { email: null, phone: null },
    capacity: "Medium",
    hours: "Wed, Fri, Sat 11:45pm-6am",
    soundSystem: "Professional system",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: null,
    social: "@plateauoficial",
    notes: "80s, pop-rock focus"
  },
  {
    id: 11,
    name: "Harbour",
    type: "After-hours",
    address: "Cais Gás Armazem A Porta 7, 1200-109 Lisboa",
    contact: { email: null, phone: null },
    capacity: 300,
    hours: "Sat-Sun 4:30am-11am",
    soundSystem: "Professional system",
    pricing: "Entry varies",
    bestFor: "Morning events",
    website: null,
    social: "Social media",
    notes: "Weekend after-hours spot"
  },
  {
    id: 19,
    name: "Carmo Rooftop",
    type: "Rooftop",
    address: "Terraços do Carmo, Largo do Carmo, 1200-288 Lisboa",
    contact: { email: null, phone: null },
    capacity: "120-500 (varies by terrace)",
    hours: "Daily noon-late",
    soundSystem: "Professional systems all levels",
    pricing: "Event rental",
    bestFor: "Sunset/Night",
    website: "carmorooftop.pt",
    social: null,
    notes: "Historic setting, panoramic views"
  },
  {
    id: 21,
    name: "Mama Shelter Lisboa Rooftop",
    type: "Rooftop",
    address: "R. do Vale de Pereiro 19, 1250-270 Lisboa",
    contact: { email: "lisboa@mamashelter.com", phone: null },
    capacity: 200,
    hours: "Jun-Oct 4pm-10:30pm",
    soundSystem: "DJ sets Thu 6-9pm",
    pricing: "€28 min Fri/Sat",
    bestFor: "Sunset",
    website: "mamashelter.com",
    social: null,
    notes: "360° city views"
  },
  {
    id: 22,
    name: "TOPO Martim Moniz",
    type: "Rooftop",
    address: "Largo Martim Moniz, Centro Comercial, Piso 6, 1100-341 Lisboa",
    contact: { email: "eventos@topo-lisboa.pt", phone: "+351 215 881 322" },
    capacity: "Multi-level",
    hours: "Sun-Wed 12:30-1am, Thu-Sat 12:30-2am",
    soundSystem: "Daily DJs",
    pricing: "Event rental",
    bestFor: "All times",
    website: null,
    social: null,
    notes: "São Jorge Castle views"
  },
  {
    id: 42,
    name: "Armazém 16",
    type: "Industrial",
    address: "R. Pereira Henriques 14, 1900-165 Lisboa",
    contact: { email: "comercial@casadacomida.pt", phone: "+351 218 115 020" },
    capacity: "Large-scale",
    hours: "By booking",
    soundSystem: "Industrial environment",
    pricing: "Event rental",
    bestFor: "All events",
    website: null,
    social: null,
    notes: "Former railway warehouse"
  },
  {
    id: 48,
    name: "LX Factory - Fábrica XL",
    type: "Industrial Complex",
    address: "R. Rodrigues de Faria 103, 1300-501 Lisboa",
    contact: { email: null, phone: null },
    capacity: "23,000m² site",
    hours: "Various events",
    soundSystem: "Multiple adaptable spaces",
    pricing: "Event rental",
    bestFor: "All events",
    website: "LX Factory",
    social: null,
    notes: "Former textile factory"
  },
  {
    id: 46,
    name: "Village Underground Lisboa",
    type: "Cultural Hub",
    address: "Avenida da Índia 52, 1300-299 Lisboa",
    contact: { email: null, phone: "+351 91 111 5533" },
    capacity: "Multiple areas",
    hours: "Thu 10pm-2am, Fri-Sat 10pm-6am",
    soundSystem: "Professional recording studio",
    pricing: "Event rental",
    bestFor: "Night events",
    website: null,
    social: "Social media",
    notes: "Shipping containers/buses venue"
  },
  {
    id: 31,
    name: "Emma Beach Club",
    type: "Beach Club",
    address: "Praia da Conceição, Cascais center",
    contact: { email: "hello@emmacascais.com", phone: null },
    capacity: "Medium",
    hours: "May-Sep 9am-7pm",
    soundSystem: "DJ potential setup",
    pricing: "€40/day loungers",
    bestFor: "Morning/Sunset",
    website: null,
    social: null,
    notes: "Water sports center included"
  },
  // Additional venues to complete the database
  {
    id: 12,
    name: "Radio Hotel",
    type: "Nightclub",
    address: "Travessa Conde da Ponte, 12, Alcântara",
    contact: { email: null, phone: null },
    capacity: 150,
    hours: "Fri-Sat nights",
    soundSystem: "Electronic sound system",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: null,
    social: "@RadioHotelLx",
    notes: "Near 25 de Abril Bridge"
  },
  {
    id: 13,
    name: "Hype Lisboa",
    type: "Nightclub",
    address: "Avenida 24 de Julho, 66, Santos",
    contact: { email: null, phone: "+351 963 551 096" },
    capacity: "Medium",
    hours: "Wed-Sat 11:45pm-6am",
    soundSystem: "Professional system",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: null,
    social: "@hype.lisbon",
    notes: "Operating since 2020, Erasmus parties"
  },
  {
    id: 14,
    name: "Incógnito",
    type: "Nightclub",
    address: "Rua dos Poiais de São Bento, 37, São Bento, 1200-346 Lisboa",
    contact: { email: null, phone: null },
    capacity: "Small-medium",
    hours: "Multiple days per week",
    soundSystem: "Professional system",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: null,
    social: "@incognitobar",
    notes: "Hidden entrance, 30+ years old"
  },
  {
    id: 15,
    name: "Copenhagen",
    type: "Nightclub",
    address: "Cais do Sodré area",
    contact: { email: null, phone: null },
    capacity: 250,
    hours: "Mon-Sun (never closes)",
    soundSystem: "Professional DJ equipment",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: null,
    social: "@Copenhagen.Lisboa",
    notes: "Hip-hop, dancehall, African music"
  },
  {
    id: 16,
    name: "5A Club",
    type: "Underground",
    address: "Rua do Noronha 5A, 1250-168 Lisboa",
    contact: { email: null, phone: null },
    capacity: 200,
    hours: "Fri 11:30pm-6am, Sat 11:30pm-8am",
    soundSystem: "Void Acoustic system",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: null,
    social: "@5aclub",
    notes: "Techno underground"
  },
  {
    id: 17,
    name: "NĀDA",
    type: "Underground",
    address: "Secret location (private events)",
    contact: { email: null, phone: null },
    capacity: 300,
    hours: "Events 12pm-11pm",
    soundSystem: "Modern sound system",
    pricing: "Private events",
    bestFor: "All-day events",
    website: null,
    social: "@nada.lisboa",
    notes: "Secret location events"
  },
  {
    id: 18,
    name: "Temple Club",
    type: "Underground",
    address: "Pátio do Pinzaleiro 26, 1200-869 Lisboa",
    contact: { email: null, phone: "+351 912 329 355" },
    capacity: "Medium",
    hours: "Fri-Sat 10pm-4am",
    soundSystem: "Professional system",
    pricing: "Entry varies",
    bestFor: "Night events",
    website: "linktr.ee/temple.lx",
    social: null,
    notes: "Techno, tech house focus"
  },
  {
    id: 20,
    name: "SEEN Sky Bar",
    type: "Rooftop",
    address: "Av. da Liberdade 185, 1269-050 Lisboa (Tivoli Hotel)",
    contact: { email: null, phone: null },
    capacity: "High capacity",
    hours: "Lunch and evenings",
    soundSystem: "Regular resident DJs",
    pricing: "Private events",
    bestFor: "Sunset sessions",
    website: null,
    social: null,
    notes: "Mediterranean/Japanese cuisine"
  },
  {
    id: 23,
    name: "Catch Me Lisboa",
    type: "Rooftop",
    address: "Jardim 9 de Abril (near Museum of Ancient Art)",
    contact: { email: null, phone: null },
    capacity: "Medium",
    hours: "Daily noon-late",
    soundSystem: "DJ sets Fri-Sat 4-8pm, 10pm-2am",
    pricing: "Event rental",
    bestFor: "Sunset/Night",
    website: null,
    social: "@catchme.lisboa",
    notes: "25th April Bridge views"
  },
  {
    id: 24,
    name: "Level Eight",
    type: "Rooftop",
    address: "Rua Castilho 14C, 1250-069 Lisboa",
    contact: { email: "level8@leveleight.pt", phone: "+351 932 111 111" },
    capacity: 200,
    hours: "Daily 5pm-2am",
    soundSystem: "Guest DJs 6-9pm",
    pricing: "Event rental",
    bestFor: "Sunset",
    website: null,
    social: null,
    notes: "350 square meters"
  },
  {
    id: 25,
    name: "Go A Lisboa",
    type: "Rooftop",
    address: "Calçada Livramento 17, 1350-188 Lisboa",
    contact: { email: null, phone: null },
    capacity: "Large-scale",
    hours: "Variable",
    soundSystem: "Regular DJ sets",
    pricing: "Event rental",
    bestFor: "All year (heated)",
    website: null,
    social: "Social media",
    notes: "Largest rooftop in Lisbon"
  },
  {
    id: 26,
    name: "Tutto Passa",
    type: "Rooftop Restaurant",
    address: "Rua da Cintura do Porto de Lisboa, Armazém B, 1200-109 Lisboa",
    contact: { email: null, phone: null },
    capacity: "Medium",
    hours: "Tue-Sun 12:30-3pm, 7:30pm-12am",
    soundSystem: "Thursday DJ sets",
    pricing: "Event rental",
    bestFor: "Night events",
    website: null,
    social: null,
    notes: "Italian cuisine, Cais do Sodré"
  },
  {
    id: 27,
    name: "Entretanto Rooftop Bar",
    type: "Hotel Rooftop",
    address: "Hotel do Chiado, Rua Nova do Almada 114, 1200-290 Lisboa",
    contact: { email: null, phone: "+351 21 325 6100" },
    capacity: "Intimate",
    hours: "Daily operations",
    soundSystem: "DJ nights",
    pricing: "Event rental",
    bestFor: "Sunset/Night",
    website: "hoteldochiado.pt",
    social: null,
    notes: "7th floor, NY Times recommended"
  },
  {
    id: 28,
    name: "SUD Lisboa Terrazza",
    type: "Pool Club",
    address: "Near MAAT, Belém area",
    contact: { email: "rsv.terrazza@sudlisboa.com", phone: null },
    capacity: "150-240",
    hours: "Daily",
    soundSystem: "Weekend DJs",
    pricing: "Premium pricing",
    bestFor: "Sunset",
    website: "sudlisboa.com",
    social: null,
    notes: "Infinity pool, 25 April Bridge views"
  },
  {
    id: 29,
    name: "Silk Club Terrace",
    type: "Exclusive Rooftop",
    address: "Rua da Misericórdia, 14, Chiado",
    contact: { email: null, phone: "+351 913 009 193" },
    capacity: "60+",
    hours: "Closed Sun-Mon",
    soundSystem: "Resident DJ",
    pricing: "High-end",
    bestFor: "Night events",
    website: "silk-club.com",
    social: null,
    notes: "Japanese cuisine, 360° views"
  },
  {
    id: 30,
    name: "Icon Rooftop",
    type: "Hotel Rooftop",
    address: "Rua da Junqueira, 65, Belém (Hyatt Regency)",
    contact: { email: null, phone: "+351 219 023 207" },
    capacity: "60+",
    hours: "Daily",
    soundSystem: "DJ music atmosphere",
    pricing: "Event rental",
    bestFor: "Sunset",
    website: "iconrooftop.com",
    social: null,
    notes: "River and bridge views"
  }
];